import React, { useState, useEffect } from 'react';

const faqs = [
  {
    question: 'What is included in the Master ChatGPT Course + 3000 Prompts?',
    answer:
      "You’ll get a step-by-step video course to Master ChatGPT and 3000+ ready-to-use prompts for creating content, marketing, writing, learning, and boosting productivity instantly.",
  },
  {
    question: 'Who can benefit the most from this Master ChatGPT course?',
    answer:
      'Business owners, students, freelancers, content creators, marketers, educators, job seekers, and anyone wanting to save time, increase creativity, and grow faster.',
  },
  {
    question: 'Do I need any prior experience to Master ChatGPT?',
    answer:
      'Not at all! The course is designed for complete beginners as well as experienced users who want to maximize results with ChatGPT',
  },
  {
    question: 'How will 3000 prompts help me Master ChatGPT?',
    answer:
      'These prompts act like ready-made commands for ChatGPT, helping you get accurate, high-quality results without spending hours figuring out what to ask.',
  },
  {
    question: 'Will this Master ChatGPT course help me earn money?',
    answer:
      'Yes! By using the skills and prompts you’ll learn, you can create content faster, complete client projects easily, and explore multiple income opportunities.',
  },
  {
    question: 'How will 3000 prompts help me Master ChatGPT?',
    answer:
      'Immediately! You’ll get instant access to the course and all 3000 prompts right after payment.',
  },
];

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <>
      {/* Animations & Mobile Styles */}
      <style>{`
        @keyframes slideDown {
          0% { opacity: 0; transform: translateY(-10px); max-height: 0; }
          100% { opacity: 1; transform: translateY(0); max-height: 500px; }
        }

        .accordion-body-animate {
          animation: slideDown 0.3s ease-out forwards;
        }

        @keyframes wiggle {
          0% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          50% { transform: translateX(5px); }
          75% { transform: translateX(-5px); }
          100% { transform: translateX(0); }
        }

        .wiggle {
          animation: wiggle 0.6s ease-in-out infinite;
        }

        /* Mobile responsive adjustments */
        @media (max-width: 768px) {
          .faq-container {
            padding: 40px 15px !important;
          }
          .faq-heading {
            font-size: 22px !important;
          }
          .faq-subtext {
            font-size: 14px !important;
          }
          .accordion-header {
            padding: 12px 15px !important;
            font-size: 16px !important;
          }
          .accordion-body {
            font-size: 15px !important;
            padding: 12px 15px !important;
          }
        }
      `}</style>

      <div style={styles.container} className="faq-container">
        <h2 style={styles.heading} className="faq-heading">
          Frequently Asked <span style={styles.highlight}>Questions</span>
        </h2>
        <p style={styles.subtext} className="faq-subtext">All your burning questions answered.</p>

        <div style={styles.accordionWrapper}>
          {faqs.map((faq, index) => (
            <div key={index} style={{ marginBottom: '20px' }}>
              <div
                style={{
                  ...styles.accordionHeader,
                  backgroundColor: index === activeIndex ? '#f85a40' : '#1c213c',
                }}
                className="accordion-header"
                onClick={() => toggleAccordion(index)}
              >
                <span>{faq.question}</span>
                <span style={styles.icon}>{index === activeIndex ? '−' : '+'}</span>
              </div>
              {index === activeIndex && (
                <div style={styles.accordionBody} className="accordion-body accordion-body-animate">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

const styles = {
  container: {
    background: 'radial-gradient(107.67% 107.67% at 50% 20.81%, #000B3E 0%, #020202 100%)',
    padding: '40px 20px',
    color: '#fff',
    textAlign: 'center',
    minHeight: '100vh'
  },
  heading: {
    fontSize: '32px',
     fontWeight: '900',
  },
  highlight: {
    color: '#f85a40',
  },
  subtext: {
    fontSize: '16px',
    marginBottom: '30px',
    color: '#ccc',
  },
  accordionWrapper: {
    maxWidth: '900px',
    margin: '0 auto',
    textAlign: 'left',
  },
  accordionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 20px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: '600',
    fontSize: '17px',
    color: '#fff',
    transition: 'background-color 0.3s ease',
  },
  icon: {
    fontSize: '20px',
    fontWeight: 'bold',
  },
  accordionBody: {
    backgroundColor: '#252b4a',
    padding: '16px 20px',
    borderRadius: '8px',
    fontSize: '15px',
    lineHeight: '1.6',
  },
};

export default FAQSection;
